module.exports = __webpack_public_path__ + "static/img/welcome-lifelong-worldwide-24.4443bd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/welcome-lifelong-worldwide-24.png
// module id = X+KW
// module chunks = 1